import { getCurrentUserV3, getIntercomJwt as getIntercomJwtV3 } from '@helios/frontend-api-v2-client';
import request from '../../api/index';
import { BankAccountValidationResponse, SabalAccount, UpdateUser, User } from '../../api/user/types';
import { UtilityRateFlowLoginResponse, UtilityRatePlanScope } from '../../api/utilityRatePlan/types';

export async function getUser(): Promise<User> {
  const { data } = await getCurrentUserV3({ throwOnError: true });
  return data;
}

export async function putUser(user: UpdateUser): Promise<User> {
  const result = await request({ method: 'put', url: '/user', data: user });
  return result.data;
}

export async function getBankAccountValidationResult(requestId?: string): Promise<BankAccountValidationResponse> {
  const result = await request({ url: `/user/bank-account-validation-results/${requestId}` });
  return result.data;
}

export async function getSabalAccounts(): Promise<SabalAccount[]> {
  const result = await request({ url: `/user/sabal-accounts` });
  return result.data;
}

export async function getUtilityRateFlowLogin(
  scope: UtilityRatePlanScope,
  planId?: string,
  context?: string,
): Promise<UtilityRateFlowLoginResponse> {
  const result = await request({
    method: 'post',
    url: `/user/light-energy-flow-link`,
    data: { scope, planId, context },
  });
  return result.data;
}

export async function checkPhoneInUse(phone: string): Promise<{ inUse: boolean }> {
  const result = await request({
    method: 'post',
    url: '/user/phone-in-use',
    data: { phone },
  });
  return result.data;
}

export async function getIntercomJwt(): Promise<{ token: string }> {
  const { data } = await getIntercomJwtV3({ throwOnError: true });
  return data;
}
